import { render } from "./Biao.vue?vue&type=template&id=98b4fbce&scoped=true"
import script from "./Biao.vue?vue&type=script&lang=js"
export * from "./Biao.vue?vue&type=script&lang=js"

import "./Biao.vue?vue&type=style&index=0&id=98b4fbce&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b4fbce"]])

export default __exports__